import { StyleSheet } from "react-native";
import { formScreen } from "../Styles/formScreen";
import { mainScreen } from "../Styles/mainScreen";

export default StyleSheet.create({
  ...formScreen,
  iconEdit: {
    position: "absolute",
    top: 5,
    right: 0,
  },
  containerForm: {
    flex: 1,
    width: "100%",
    alignItems: "center",
    backgroundColor: "#aa000000",
    paddingBottom: 50,
  },
  label: {
    color: "#FFF",
    alignItems: "center",
    paddingLeft: 8,
    fontSize: 20,
  },
  containerRow: {
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    marginTop: 16,
  },
  personalData: {
    borderRadius: 8,
    backgroundColor: "#000A",
    marginTop: 10,
  },
  dataProperty: {
    fontFamily: "Montserrat-Medium",
    fontSize: 14,
    color: "#F1F1F1",
  },

  dataValue: {
    fontFamily: "Montserrat",
    marginTop: 2,
    fontSize: 15,
    color: "#C1C1C1",
    marginBottom: 16,
  },
  alert: {
    color: "#999",
    textAlign: "center",
  },

  hr: { width: "95%", padding: 1, marginTop: 10, backgroundColor: "#CCC9" },
});
